import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { ReactComponent as IconLeft } from 'assets/left.svg';
import { ReactComponent as IconRight } from 'assets/right.svg';
import { ReactComponent as IconRightAct } from 'assets/rightAct.svg';

const Navigation = ({
  result,
  data,
  SetAnsw,
  SubAnsw,
  step,
  setStep,
  next,
  answer,
}) => {
  const [revers, setRevers] = useState(true);

  console.log('next', next);
  // setStep(5)

  useEffect(() => {
    let temp = 0;
    for (let key in result) {
      if (result[key].type === 'menu') {
        temp++;
      }
    }
    if (temp === (data && data.mainMenu.modules.length)) {
      setRevers(false);
    }
  }, [result]);

  const nextBtn = () => {
    if (next) {
      if (step === 2 || step === 3) {
        SubAnsw(answer);
      } else {
        SetAnsw(answer);
      }
      if (step === 3 && revers) {
        setStep(1);
      } else {
        setStep(step + 1);
      }
    }
  };

  return (
    <div className="navigation">
      <div className="nav-btn" onClick={() => setStep(step - 1)}>
        <IconLeft />
      </div>
      <div
        className={classnames('nav-btn', { disable: !next, active: next })}
        onClick={nextBtn}
      >
        { !next &&  <IconRight />  }
        { next &&  <IconRightAct />  }
        
      </div>
    </div>
  );
};

export default Navigation;
